import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { GLOBAL } from '../../global/global';
import { LoginService } from 'app/main/login/login.service';
import { Checklist } from '../../models/checklist.model';
import { Question } from '../../models/question.model';
import { ChecklistQuestions } from '../../models/checklist-questions.model';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ',
    })
};


@Injectable({
    providedIn: 'root'
})
export class ChecklistService implements Resolve<any>
{
    public urlAPI: string;
    dataAll: any[];
    dataAllQuestions: ChecklistQuestions[];
    onChecklistChanged: BehaviorSubject<any>;
    onQuestionChanged: BehaviorSubject<any>;
    currentCheck: Checklist;

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient,
        private _loginService: LoginService
    )
    {
        // Set the defaults
        this.onChecklistChanged = new BehaviorSubject({});
        this.onQuestionChanged = new BehaviorSubject({});
        this.urlAPI = GLOBAL.url;
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        return new Promise((resolve, reject) => {

            this.dataAllQuestions = [];
            Promise.all([
                this.getData()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Get dataAll
     *
     * @returns {Promise<any>}
     */
    getData(): Promise<any>
    {
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'checklist', httpOptions)
                .subscribe(
                    (response: any) => {
                        this.dataAll = response.data.checklist;
                        this.onChecklistChanged.next(this.dataAll);
                        resolve(response);
                 }, reject);
        });
    }

    /**
     * Save a new data
     * @param token
     * @param car
     */
    create(data): Promise<any>{
        let dataJson = data;

        const myData = {
            data: {
                checklist: dataJson
            }
        };
        const myParam = JSON.stringify(myData);

        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.urlAPI + 'checklist', myParam, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

    /**
     * Get data of item
     * @param token
     * @param car
     */
    getOne(id): Promise<any>{
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'checklist/' + id, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

    /**
     * Update data
     * @param token
     * @param car
     */
    update(data): Promise<any>{
        let dataJson = data;
        const myData = {
            data: {
                checklist: dataJson
            }
        };
        const myParam = JSON.stringify(myData);

        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.put(this.urlAPI + 'checklist/' + data.id, myParam, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });
    }

    /**
     * Get dataAll
     *
     * @returns {Promise<any>}
     */
    questionGetData(checklistId: number, groupId: number): Promise<any>
    {
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'checklist-questions/bychecklist/' + checklistId + '/' + groupId, httpOptions)
                .subscribe(
                    (response: any) => {
                        this.dataAllQuestions = response.data.checklist_questions;
                        this.onQuestionChanged.next(this.dataAllQuestions);
                        resolve(response);
                    }, reject);
        });
    }

    setCurrentCheck(dataCheck: Checklist): void{
        this.currentCheck = dataCheck;
    }

    serviceTypeGetAll(): Promise<any>
    {
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'servicetypes', httpOptions)
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    }, reject);
        });
    }

    groupQuestionGetByServiceType(serviceId): Promise<any>
    {
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'questiongroups/byservice/' + serviceId, httpOptions)
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    }, reject);
        });
    }

    /**
     * Delete a question from CheckList
     * @param id
     * @returns {Promise<T>}
     */
    questionDelete(id): Promise<any>{
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.delete(this.urlAPI + 'checklist-questions/' + id, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });
    }

    /**
     * Get questions by group
     *
     * @param handle
     * @returns {Promise<Todo[]>}
     */
    getPreguntasDisponiblesByGroup(idCheck, idGroup): Promise<Question[]>
    {
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'checklist-questions/question-available/by-group/' + idCheck + '/' + idGroup, httpOptions)
                .subscribe(
                    (response: any) => {
                        resolve(response.data.questions);
                    }, reject);
        });

    }

    /**
     * Save a new data
     * @param token
     * @param car
     */
    checklistQuestionCreate(checklistId: number, questionsIds: number[]): Promise<any>{
        const myData = {
            data: {
                checklist_question: {
                    checklist_id: checklistId,
                    questions: questionsIds
                }
            }
        };
        const myParam = JSON.stringify(myData);

        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.urlAPI + 'checklist-questions', myParam, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

}
